import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { useTheme } from '../../context/ThemeContext'
import {
  IconLayoutDashboard, IconBuilding, IconMap2, IconUsersGroup,
  IconLogout, IconMoon, IconSun, IconShieldCog, IconBuildingSkyscraper
} from '@tabler/icons-react'

const NAV_ITEMS = [
  { path: '/corporate', label: 'Portfolio Dashboard', icon: IconLayoutDashboard, end: true },
  { path: '/corporate/hotels', label: 'Hotels', icon: IconBuilding },
  { path: '/corporate/regions', label: 'Regions', icon: IconMap2 },
  { path: '/corporate/team', label: 'Corporate Team', icon: IconUsersGroup },
]

export default function CorporateLayout() {
  const { user, managementCompany, logout, isPlatformAdmin } = useAuth()
  const { dark, toggle } = useTheme()
  const navigate = useNavigate()

  const handleLogout = async () => { await logout(); navigate('/login') }
  const initials = user?.name?.split(' ').map(n => n[0]).join('').toUpperCase() || '?'

  return (
    <div className="d-flex" style={{ minHeight: '100vh' }}>
      <aside className="navbar navbar-vertical navbar-expand-lg" data-bs-theme="dark" style={{ width: 260, flexShrink: 0 }}>
        <div className="container-fluid d-flex flex-column h-100">
          <h1 className="navbar-brand navbar-brand-autodark mb-0">
            <span className="d-flex align-items-center gap-2">
              <IconBuildingSkyscraper size={28} />
              <span>
                <strong>Leadiox</strong>
                <small className="d-block text-secondary" style={{ fontSize: '0.7rem', marginTop: -2 }}>Corporate Portal</small>
              </span>
            </span>
          </h1>

          {managementCompany && (
            <div className="px-3 mb-2">
              <div className="badge bg-blue-lt w-100 py-2" style={{ fontSize: '0.8rem' }}>
                {managementCompany.name}
              </div>
            </div>
          )}

          <div className="px-3 mb-2">
            <button className="btn btn-dark w-100 btn-sm d-flex align-items-center gap-2" onClick={toggle}>
              {dark ? <IconSun size={16} /> : <IconMoon size={16} />}
              {dark ? 'Light Mode' : 'Dark Mode'}
            </button>
          </div>

          <div className="flex-grow-1">
            <ul className="navbar-nav pt-lg-3">
              {NAV_ITEMS.map(item => (
                <li key={item.path} className="nav-item">
                  <NavLink to={item.path} end={item.end} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                    <span className="nav-link-icon"><item.icon size={18} /></span>
                    <span className="nav-link-title">{item.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {isPlatformAdmin() && (
            <div className="px-3 mt-3 pt-3 border-top border-secondary">
              <NavLink to="/admin" className="btn w-100 btn-sm d-flex align-items-center gap-2" style={{ background: 'rgba(245,158,11,0.15)', color: '#f59e0b' }}>
                <IconShieldCog size={16} />Platform Admin
              </NavLink>
            </div>
          )}

          <div className="mt-auto px-3 py-3 border-top border-secondary">
            <div className="d-flex align-items-center gap-2">
              <span className="avatar avatar-sm rounded-circle bg-purple">{initials}</span>
              <div style={{ minWidth: 0, flex: 1 }}>
                <div className="text-white fw-medium" style={{ fontSize: '0.85rem', lineHeight: 1.2 }}>{user?.name}</div>
                <div className="text-secondary" style={{ fontSize: '0.7rem', textTransform: 'capitalize' }}>{user?.role?.replace(/_/g, ' ')}</div>
              </div>
              <button className="btn btn-ghost-secondary btn-sm btn-icon" onClick={handleLogout} title="Sign Out">
                <IconLogout size={18} />
              </button>
            </div>
          </div>
        </div>
      </aside>

      <main className="flex-grow-1 p-4" style={{ overflowY: 'auto', maxHeight: '100vh' }}>
        <Outlet />
      </main>
    </div>
  )
}
